export const MAX_QUALIFICATION_AGE_IN_MONTHS = 30;

const toIsoDate = (date: Date): string => {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};

// Mirrors the backend check (PHP "-30 months"): a day that does not exist in
// the target month rolls over into the next one, so both sides agree on the limit.
const getEarliestQualificationDate = (today: Date): string => {
  return toIsoDate(
    new Date(
      today.getFullYear(),
      today.getMonth() - MAX_QUALIFICATION_AGE_IN_MONTHS,
      today.getDate(),
    ),
  );
};

export default getEarliestQualificationDate;
